import { ErrorOutlineRounded } from '@mui/icons-material';

import Text from '@components/Text';
import { t } from '@i18n';

import './CommunityNotFoundView.scss';

export default function CommunityNotFoundView() {
  return (
    <main className='checkout-mode-shell'>
      <section className='checkout-mode-card' aria-labelledby='community-not-found-title'>
        <div className='checkout-mode-icon' aria-hidden='true'>
          <ErrorOutlineRounded />
        </div>
        <Text.subheading>{t('checkout.notFound.eyebrow')}</Text.subheading>
        <Text.h2 id='community-not-found-title'>{t('checkout.notFound.title')}</Text.h2>
        <Text.p contrast={6}>{t('checkout.notFound.description')}</Text.p>
      </section>
    </main>
  );
}
